import { render, staticRenderFns } from "./FlieHeader.vue?vue&type=template&id=826e50b0&scoped=true&"
import script from "./FlieHeader.vue?vue&type=script&lang=ts&"
export * from "./FlieHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FlieHeader.vue?vue&type=style&index=0&id=826e50b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e50b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VList,VListItem,VListItemTitle,VMenu,VRow,VSpacer})
